if (!customElements.get("variant-ladder-side")) {
  customElements.define(
    "variant-ladder-side",
    class VariantLadderSide extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.section = this.closest("section");
        this.addEventListener("change", (event) => {
          if (!event.target.matches("[data-ladder-side-choice]")) return;
          const group = event.target.closest("[data-ladder-side-for]");
          const summary = group?.querySelector("[data-ladder-side-selected-label]");
          if (summary) summary.textContent = event.target.value;
          this.clearError();
        });
        this.section?.addEventListener("variantChangeEnd", (event) => {
          const picker = event.target.closest("variant-options") || event.target;
          const variantId = picker.currentVariant?.id || picker.dataset.variantId;
          if (variantId) this.updateForVariant(String(variantId));
        });
        this.section?.addEventListener("variantProductInfoRendered", (event) => {
          const variantId = event.detail?.variant?.id;
          if (variantId) this.updateForVariant(String(variantId));
        });
        this.updateForVariant(String(this.dataset.selectedVariantId || ""));
      }

      updateForVariant(variantId) {
        let visibleGroup = null;
        this.querySelectorAll("[data-ladder-side-for]").forEach((group) => {
          const show = group.dataset.ladderSideFor === variantId;
          group.hidden = !show;
          group.querySelectorAll("[data-ladder-side-choice]").forEach((input) => {
            input.disabled = !show;
          });
          if (!show) group.open = false;
          if (show) visibleGroup = group;
        });
        this.hidden = !visibleGroup;
        this.clearError();
      }

      validateSelection() {
        const group = this.querySelector("[data-ladder-side-for]:not([hidden])");
        if (!group) return true;
        const selected = group.querySelector("[data-ladder-side-choice]:checked");
        if (selected) return true;

        const error = group.querySelector("[data-ladder-side-error]");
        if (error) error.hidden = false;
        group.open = true;
        window.requestAnimationFrame(() => group.querySelector("[data-ladder-side-choice]")?.focus());
        return false;
      }

      applySelection(form) {
        const selected = this.querySelector('[data-ladder-side-for]:not([hidden]) [data-ladder-side-choice]:checked');
        let property = form.querySelector("[data-ladder-side-property]");
        if (!property) {
          property = document.createElement("input");
          property.type = "hidden";
          property.name = "properties[Ladder side]";
          property.dataset.ladderSideProperty = "";
          form.appendChild(property);
        }
        property.value = selected?.value || "";
        property.disabled = !selected;
      }

      clearError() {
        this.querySelectorAll("[data-ladder-side-error]").forEach((error) => {
          error.hidden = true;
        });
      }
    }
  );
}
